<template>
  <div class="content">
    <div class="bodycontent">
      <!-- 头部菜单 -->
      <div class="option">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="changeUrl('adlist')"
        >
          新增油品
        </el-button>
        <span>油品名称/编号/简码:</span>
        <el-input
          type="text"
          clear="search-con"
          v-model="search_con"
        ></el-input>
        <el-button @click="search">查询</el-button>
        <el-button>导出</el-button>
      </div>
      <el-table :data="listData" height="calc(100% - 120px)">
        <el-table-column label="油品名称" prop="name"></el-table-column>
        <el-table-column label="单位" prop="unit"></el-table-column>
        <!-- <el-table-column label="油品原价" prop="mktprice"> </el-table-column> -->
        <el-table-column label="油品现价" prop="price">
          <template slot-scope="scope">
            <div v-if="editFrom.showStatus == scope.row.id">
              <div>
                <el-input
                  size="mini"
                  type="number"
                  v-model="editFrom.price"
                  style=" width:120px"
                ></el-input>
              </div>
              <div style="margin-top: 10px">
                <el-button size="mini" type="primary" @click="deitPrice"
                  >保存</el-button
                >
                <el-button
                  size="mini"
                  @click="editFrom = { showStatus: 'a', price: '' }"
                  >取消</el-button
                >
              </div>
            </div>
            <div v-else>
              <span style="display:inline-block;min-width:50px">
                {{ scope.row.price }}
              </span>
              <el-button
                icon="el-icon-edit"
                size="mini"
                type="primary"
                @click="clickButton(scope.row)"
              ></el-button>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="参考进价" prop="costprice">
          <template slot-scope="scope">
            <div v-if="scope.row.costprice">
              <span>{{ scope.row.costprice }}</span>
            </div>
            <div v-else>无</div>
          </template>
        </el-table-column> -->
        <el-table-column label="多门店价格">
          <template slot-scope="scope">
            <div v-if="scope.row.is_spec">
              <el-button type="text" @click="watchSpec(scope.row.specs)"
                >查看</el-button
              >
            </div>
            <div v-else>无</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time"></el-table-column>

        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="120px"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row.id)"
              >编辑</el-button
            >
            <el-button type="text" @click="delItem(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage" v-if="page_status">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <el-dialog
        :visible.sync="showSpec"
        width="480px"
        @close="showSpec = false"
        title="多门店价格"
      >
        <el-table :data="specData">
          <el-table-column label="门店" prop="room_name"></el-table-column>
          <el-table-column label="价格" prop="price"></el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { goodsList, goodsDel, goodsEdit } from "@/api/vip";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      listData: [], //列表
      keyword: "", //关键字筛选
      page: 1,
      total: 0,
      search_con: "",
      page_status: false,
      loading: true, //页面loading
      showSpec: false, //显示多门店价格
      specData: [], //多门店价格列表
      editFrom: {
        showStatus: "a",
        price: ""
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    clickButton(row) {
      this.editFrom = Object.assign(this.editFrom, row);
      this.editFrom.showStatus = row.id;
      console.log("xiangxishuju", this.editFrom);
    },
    // 路由跳转
    changeUrl(url) {
      this.$router.push(url);
    },
    getData() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        name: this.search_con,
        store_id: 0
      };
      goodsList(data).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.total = res.total;
            if (res.last_page > 1) this.page_status = true;
            this.listData = res.data;
            this.loading = false;
          } else {
            this.loading = false;
          }
        } else {
          this.listData = [];
          this.loading = false;
          this.$message.error("暂无数据...");
        }
      });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    //跳页
    handleCurrentChange(p) {
      this.page = p;
      this.getData();
    },
    //查看多门店价格
    watchSpec(data) {
      // data对象类型转数组类型
      var arr = [];
      for (var i in data) {
        arr.push(data[i]);
      }
      this.specData = arr;
      this.showSpec = true;
    },
    //编辑
    editItem(id) {
      this.$router.push({ path: "adlist", query: { sid: id } });
    },
    deitPrice() {
      console.log("編輯數據", this.editFrom);
      delete this.editFrom.create_time;
      delete this.editFrom.delete_time;
      delete this.editFrom.update_time;

      this.editFrom.app_id = this.app_id;
      this.editFrom.token = this.token;
      //修改
      goodsEdit(this.editFrom).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.editFrom = {
            showStatus: "a",
            price: ""
          };
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //新增
    addGoods() {
      this.$router.push({ path: "adlist" });
    },
    //删除
    delItem(i) {
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: i
          };
          goodsDel(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.getData();
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../sub_com.scss";
.option {
  width: 100%;
  height: 80px;
  display: flex;
  font-size: 16px;
  padding-left: 20px;
  align-items: center;
  background: #ffffff;
  span {
    margin-left: 20px;
  }
  .el-input {
    width: 300px;
    margin: 0 20px;
  }
}
// table
.el-table {
  flex: 1;
  box-shadow: 0 0 3px #f1f1f1;
  padding-left: 10px;
}
.level_img {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}
//表格中的商品内容
.table_line {
  height: 20px;
  line-height: 20px;
  white-space: space wrap;
}
//分页
.Otherpage {
  width: 100%;
  height: 34px;
  line-height: 34px;
  background: #ffffff;
}
</style>
